var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.61 4.223A.901.901 0 0 0 12 4a.901.901 0 0 0-.61.223L6.19 8.96c-.202.187-.247.45-.116.674.13.223.414.366.726.366h10.4c.312 0 .595-.143.726-.366.13-.224.086-.487-.116-.674l-5.2-4.737zm0 15.554A.901.901 0 0 1 12 20a.901.901 0 0 1-.61-.223l-5.2-4.737c-.202-.187-.247-.45-.116-.674.13-.223.414-.366.726-.366h10.4c.312 0 .595.143.726.366.13.224.086.487-.116.674l-5.2 4.737z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrows);
export default __webpack_public_path__ + "static/media/filterArrows.0ad76ba3.svg";
export { ForwardRef as ReactComponent };